<template>
  <sqr-modal @close="$emit('close')">
    <div>
      <h1 class="font-semibold text-lg mb-3">
        {{ $t('patient_select_modal_title') }}
      </h1>
      <div class="flex flex-col space-y-2 mb-6">
        <router-link
          :to="{
            name: 'patient-add',
            query: { update: 'invoice', updateId: invoiceId }
          }"
        >
          <sqr-button
            class="w-full text-left"
            :label="$t('invoice_patient_add')"
            color="blue"
            light
          >
            <template slot="icon">
              <UserAddIcon class="inline w-4 h-4 stroke-current" />
            </template>
          </sqr-button>
        </router-link>
        <router-link
          :to="{
            name: 'invoice-patient',
            params: { id: invoiceId },
            query: { validation }
          }"
        >
          <sqr-button
            class="w-full text-left"
            :label="$t('invoice_patient_edit')"
            color="light"
          >
            <template slot="icon">
              <PencilIcon class="inline w-4 h-4 stroke-current" />
            </template>
          </sqr-button>
        </router-link>
        <div class="help is-danger" v-if="validation">
          {{ $t('validation_general') }}
        </div>
      </div>
      <h2 class="font-semibold text-lg mb-3">
        {{ $t('patient_select_modal_choose') }}
      </h2>
      <sqr-progress color="primary" v-show="loading" />
      <sqr-error-text :error="loadError" />
      <div style="max-height: 50vh;" class="overflow-y-scroll">
        <a
          v-for="patient in patients"
          :key="patient.id"
          class="block cursor-pointer hover:bg-green-50 px-4 py-2"
          @click="select(patient)"
        >
          <span class="font-medium">{{ patient.familyName }}</span
          >,
          {{ patient.givenName }}
        </a>
      </div>
    </div>
  </sqr-modal>
</template>

<script>
import { mapState } from 'vuex';
import { sortWith, ascend, prop } from 'ramda';
import SqrModal from '@/components/SqrModal';
import SqrProgress from '@/components/SqrProgress';
import SqrErrorText from '@/components/SqrErrorText';
import SqrButton from '@/components/SqrButton';
import { PencilIcon, UserAddIcon } from '@vue-hero-icons/outline';

const nameSort = sortWith([
  ascend(prop('familyName')),
  ascend(prop('givenName'))
]);

export default {
  name: 'PatientSelectModal',
  components: {
    SqrModal,
    SqrProgress,
    SqrErrorText,
    SqrButton,
    UserAddIcon,
    PencilIcon
  },
  props: {
    invoiceId: { type: String },
    validation: { type: Boolean }
  },
  computed: {
    ...mapState('patientsIndex', { index: 'doc' }),
    ...mapState('patientsIndex', ['loading', 'loadError']),
    patients() {
      const patients = Object.entries(this.index?.patients ?? {}).map(
        ([id, patient]) => ({
          ...patient,
          id
        })
      );
      return nameSort(patients);
    }
  },
  methods: {
    select(patient) {
      this.$emit('selected', patient);
    }
  }
};
</script>
